"use client";

import { gsap } from "@/mono/lib/gsap";
import { useFrame } from "@react-three/fiber";

import { useCallback, useEffect, useMemo, useRef } from "react";
import { create } from "zustand";

//gsap.ticker.remove(gsap.updateRoot);

export const delta = create(() => ({ d: 0 }));

/**
 * Syncs all RAFs to R3F's frame loop
 * @returns
 */
export function useSyncRAFs() {
  const pg = useRef(0);

  //gsap.ticker.remove(gsap.updateRoot);

  useFrame(({ clock }, _d) => {
    const t = clock.getElapsedTime();
    pg.current += _d;
    delta.setState({ d: _d });

    // TODO:
    //lenis.raf(t * 1000);

    //gsap.updateRoot(pg.current);
  });

  // useEffect(() => {
  //   return () => {
  //     gsap.ticker.remove(gsap.updateRoot);
  //   };
  // });
}

export function useTicker(
  callback,
  { initiallyActive = false, targetFPS = null } = {},
  deps = []
) {
  const isActive = useRef(false);
  const loop = useCallback(
    (time, delta, frame) => {
      callback({
        time,
        delta: targetFPS ? gsap.ticker.deltaRatio(targetFPS) : delta / 1000,
        frame,
      });
    },
    [callback, targetFPS, ...deps]
  );

  const start = useCallback(() => {
    if (isActive.current) return;
    isActive.current = true;
    gsap.ticker.add(loop);
  }, [callback, ...deps]);

  const stop = useCallback(() => {
    if (!isActive.current) return;
    isActive.current = false;
    gsap.ticker.remove(loop);
  }, [callback, ...deps]);

  useEffect(() => {
    if (initiallyActive) start();
  }, []);

  return { start, stop, isActive: () => isActive.current };
}

/**
 * HINT: Native RAF loop, use only when gsap is not available
 * @param {*} callback
 * @param {*} initiallyActive
 * @returns
 */
export default function useRafLoop(callback, initiallyActive = false) {
  const raf = useRef(null);
  const rafActivity = useRef(false);
  const rafCallback = useRef(callback);

  rafCallback.current = callback;

  const step = useCallback((time) => {
    if (rafActivity.current) {
      rafCallback.current(time);
      raf.current = requestAnimationFrame(step);
    }
  }, []);

  const api = useMemo(
    () => ({
      stop: () => {
        if (rafActivity.current) {
          rafActivity.current = false;
          raf.current && cancelAnimationFrame(raf.current);
        }
      },
      start: () => {
        if (!rafActivity.current) {
          rafActivity.current = true;
          raf.current = requestAnimationFrame(step);
        }
      },
      isActive: () => rafActivity.current,
    }),
    []
  );

  useEffect(() => {
    if (initiallyActive) {
      api.start();
    }

    return () => {
      if (rafActivity.current) api.stop();
    };
  }, []);

  return api;
}
